import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
//utils
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import {
  IdType,
  Row,
  TableOptions,
  useColumnOrder,
  useFlexLayout,
  useGlobalFilter,
  usePagination,
  useResizeColumns,
  useRowSelect,
  useSortBy,
  useTable,
} from 'react-table'

//components

//style & scss
import classes from './Table.module.scss'

//messages & translations
import messages from './module/messages'

import moment from 'moment'
import { filter, isNil, toLower } from 'ramda'
import { FaFileCsv } from 'react-icons/fa'
import { FormattedMessage } from 'react-intl'
import { IColumnDefinitionType, TableIncomingData } from '../../models/Tables'
import Pagination from './components/Pagination'
import { ITableProps } from './module/constants'
import {
  checkDatasourceForWrapText,
  dataTableBlock,
  dataTableBR,
  dataTableChange,
  dataTableCheckbox,
  dataTableDelete,
  dataTableDetail,
  dataTableDownload,
  dataTableModify,
  dataTablePassword,
  dataTableReplayable,
  dataTableReset,
  dataTableTemporary,
  dataTableUnlock,
  dataTableUserDetail,
  dataTableViolationVisibility,
  IdataTableConstructor,
  TableCheckbox,
} from './utils'

// IMPORT MODULES FOR PRINTING "CSV" FILE OF THE DATASET
import { CSVLink } from 'react-csv'
import { createStructuredSelector } from 'reselect'
import { selectTablesConfiguration } from '../../common/TablesConfiguration/tcSelectors'
import { setTableConfigurationState } from '../../common/TablesConfiguration/tcUtils'

let pNumber = 0
let pSize = 10

const Table: React.FC<ITableProps> = (props: ITableProps): JSX.Element => {
  // Create a state

  const customFilter = (filterField: any | any[], row: Row<any>) => {
    if (Array.isArray(filterField.value)) {
      const reqDate = row.values[filterField.id]
      const rowDate = moment(reqDate, 'DD/MM/YYYY - HH:mm')
      const startDate = filterField.value[0]
        ? moment(filterField.value[0])
        : null
      const endDate = filterField.value[1] ? moment(filterField.value[1]) : null

      if (startDate && endDate) {
        return rowDate.isBetween(startDate, endDate)
      } else if (startDate && !endDate) {
        return rowDate.isAfter(startDate)
      } else {
        return rowDate.isBefore(endDate)
      }
    } else {
      if (
        row.values[filterField.id] &&
        String(row.values[filterField.id]).trim() !== '' &&
        toLower(String(row.values[filterField.id])) &&
        toLower(String(row.values[filterField.id])).includes(
          toLower(filterField.value.toString())
        )
      ) {
      }
      return (
        row.values[filterField.id] &&
        String(row.values[filterField.id]).trim() !== '' &&
        toLower(String(row.values[filterField.id])) &&
        toLower(String(row.values[filterField.id])).includes(
          toLower(filterField.value.toString())
        )
      )
    }
  }

  const ourGlobalFilterFunction = useCallback(
    (rows: Row<any>[], ids: IdType<any>[], query: any) => {
      const condiction = (row: any) => {
        let res = false
        for (let i = 0; i < query.length; i++) {
          const element = query[i]

          if (isNil(element) || isNil(row.values[element.id])) {
            res = false
            break
          }

          if (element.operation === 'OR' && customFilter(element, row)) {
            res = true
            break
          }

          if (element.operation === 'AND' && customFilter(element, row)) {
            res = true
            // break;
          }

          if (element.operation === 'AND' && !customFilter(element, row)) {
            res = false
            break
          }
        }
        return res
      }
      if (query.length > 0) {
        // console.log(filter(condiction, rows), "filter(condiction, rows)");
        return filter(condiction, rows)
      }
      return rows
    },
    []
  )

  const {
    SODDeletedSummary,
    dataSource,
    rowsChangeable,
    showDetail,
    showBrInfo,
    detailURL,
    changeLocation,
    areRowDeletable,
    onDeleteRow,
    areRowEditable,
    onEditRow,
    areRowReplayable,
    onReplay,
    areRowDownloadable,
    onDownloadRow,
    selectAll,
    showChekbox,
    onCheckboxChange,
    violationOfVisibility,
    temporary,
    showWhiteAndBlack,
    pageSizeProp,
    initialState = {
      hiddenColumns: [
        'emptyColumn0',
        'emptyColumn1',
        'emptyColumn2',
        'emptyColumn3',
        'emptyColumn4',
        'emptyColumn5',
        'emptyColumn6',
        'emptyColumn7',
        'emptyColumn8',
        'emptyColumn9',
        'emptyColumn10',
        'emptyColumn11',
        'emptyColumn12',
        'emptyColumn13',
        'emptyColumn14',
      ],
    },
    showCTAButton = false,
    onCheckboxChangeEvent = false,
    onDetailClick,
    onUserDetailClick,
    filterProps,
    summaryDetail,
    isBR,
    onInfoBR,
    isPassword,
    onPasswordClick,
    columnOrder,
    tableName = 'CSV_Table',
    CSVData,
    CSVDisabled = false,
    onClickCSV,
    CSVRef,
    // SERVER SIDE PAGINATION
    serverSidePagination,
    fetchData,
    pageCount: controlledPageCount,
    pageIndexProp,
    totalElements,
    sectionType,
    tableType,
    tablesConfiguration,
    showUserDetail,
    showUnlock,
    showReset,
    showChange,
    showBlock,
    onUnlockRow,
    onResetRow,
    onChangeRow,
    onBlockRow,
    serverSideSorting = false,
    sortByProp,
  } = props

  // TABLES CONFIGURATION
  const [customColumnOrder, setCustomColumnOrder] = useState(
    columnOrder ? columnOrder : []
  )
  const [customHideCells, setCustomHideCells] = useState({})
  const [customHideColumns, setCustomHideColumns] = useState({})

  useEffect(() => {
    let requestTableConfiguration = tablesConfiguration.filter(
      (table) => table.section === sectionType && table.type === tableType
    )
    if (requestTableConfiguration[0]) {
      setTableConfigurationState(
        requestTableConfiguration[0],
        setCustomColumnOrder,
        setCustomHideCells,
        setCustomHideColumns
      )
    }
  }, [tablesConfiguration])

  const tempData =
    CSVData && CSVData.length > 0
      ? [...CSVData]
      : dataSource?.length
      ? [...dataSource]
      : []
  // CSVData && CSVData.length > 0 ? [...CSVData] : [...dataSource];

  const actualDate = moment().format('DD/MM/YYYY')

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tempColumns: IColumnDefinitionType[] = []

  function datetime(rowA: any, rowB: any, columnId: any) {
    let [a, b] = getRowValuesByColumnID(rowA, rowB, columnId)
    const start = moment(a)
    const end = moment(b)
    return start.isSame(end) ? 0 : start.isAfter(end) ? 1 : -1
  }

  function getRowValuesByColumnID(row1: any, row2: any, columnId: any) {
    return [row1.values[columnId], row2.values[columnId]]
  }

  if (dataSource && dataSource.length > 0) {
    Object.keys(dataSource[0]).map((key) => {
      return tempColumns.push({
        Header: key.toUpperCase(),
        accessor: key,
        // @ts-ignore
        sortType:
          key.toLocaleLowerCase().includes('date') ||
          key.toLocaleLowerCase().includes('create')
            ? datetime
            : 'basic',
      })
    })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(() => tempColumns, [dataSource])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = useMemo(() => dataSource, [dataSource])

  const chooseConstractorTable = (
    showDetail: boolean = false,
    showUserDetail: boolean = false,
    showChekbox: boolean = false,
    areRowEditable: boolean = false,
    areRowDeletable: boolean = false,
    areRowDownloadable: boolean = false,
    areRowReplayable: boolean = false,
    onReplay: any,
    violationOfVisibility: boolean = false,
    temporary: boolean = false,
    showUnlock: boolean = false,
    showReset: boolean = false,
    showChange: boolean = false,
    showBlock: boolean = false
  ) => {
    if (showDetail) return showChekbox ? dataTableCheckbox : dataTableDetail
    if (showChekbox) return dataTableCheckbox
    if (showUnlock) return dataTableUnlock
    if (showReset) return dataTableReset
    if (showChange) return dataTableChange
    if (showBlock) return dataTableBlock
    if (areRowEditable) return dataTableModify
    if (areRowDeletable) return dataTableDelete
    if (areRowDownloadable) return dataTableDownload
    if (areRowReplayable) return dataTableReplayable
    if (showUserDetail) return dataTableUserDetail
    return dataTableDetail
  }

  //condizione che decide quale oggetto andra a costruire la tabella
  const dataTable: IdataTableConstructor = chooseConstractorTable(
    showDetail,
    showUserDetail,
    showChekbox,
    areRowEditable,
    areRowDeletable,
    areRowReplayable,
    areRowDownloadable,
    violationOfVisibility,
    temporary,
    showUnlock,
    showReset,
    showChange,
    showBlock
  )

  const defaultColumn = useMemo(
    () => ({
      // When using the useFlexLayout:
      minWidth: 10, // minWidth is only used as a limit for resizing
      width: 50, // width is used for both the flex-basis and flex-grow
      maxWidth: 80, // maxWidth is only used as a limit for resizing
    }),
    []
  )

  const dataHooks: TableOptions<{}> = showChekbox
    ? {
        columns: columns,
        data,
        globalFilter: ourGlobalFilterFunction,
        initialState: {
          pageIndex: pageIndexProp || 0,
          pageSize: pageSizeProp || 10,
          sortBy: sortByProp || [],
          hiddenColumns: [
            'emptyColumn0',
            'emptyColumn1',
            'emptyColumn2',
            'emptyColumn3',
            'emptyColumn4',
            'emptyColumn5',
            'emptyColumn6',
            'emptyColumn7',
            'emptyColumn8',
            'emptyColumn9',
            'emptyColumn10',
            'emptyColumn11',
            'emptyColumn12',
            'emptyColumn13',
            'emptyColumn14',
          ],
        },
        defaultColumn,
        manualPagination: serverSidePagination,
        manualSortBy: serverSidePagination,
        pageCount: controlledPageCount,
      }
    : {
        columns: columns,
        data,
        getRowId: (row: TableIncomingData) => {
          // needed for users table re-mapping

          return (
            row.uniqueId ||
            row.id ||
            row.id_user ||
            row.entitlement_id ||
            row.entitlementId ||
            row.beneficiary_id ||
            row.delegation_id ||
            row.task_id ||
            row.application_id ||
            row.br_id ||
            row.certificationItemId ||
            row.attachId ||
            row.itemId ||
            row.sodConflictId ||
            row.propagationId ||
            row.idRole ||
            row.sodConflictId ||
            row.code ||
            row.identityApplicationId ||
            row.idProperty ||
            row.idTicketTemplate ||
            row.idExternal ||
            row.serviceRequestId ||
            row.codeBusinessRole ||
            row.configuration ||
            row.counterCode ||
            row.tiCode
          )
        },
        globalFilter: ourGlobalFilterFunction,
        initialState: {
          pageIndex: pageIndexProp || 0,
          pageSize: pageSizeProp || 10,
          sortBy: sortByProp || [],
          hiddenColumns: [
            'emptyColumn0',
            'emptyColumn1',
            'emptyColumn2',
            'emptyColumn3',
            'emptyColumn4',
            'emptyColumn5',
            'emptyColumn6',
            'emptyColumn7',
            'emptyColumn8',
            'emptyColumn9',
            'emptyColumn10',
            'emptyColumn11',
            'emptyColumn12',
            'emptyColumn13',
            'emptyColumn14',
          ],
          selectedRowIds: { ...initialState },
        },
        defaultColumn,
        manualPagination: serverSidePagination,
        manualSortBy: serverSidePagination,
        pageCount: controlledPageCount,
      }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    pageOptions,
    pageCount,
    state: { pageIndex, pageSize, sortBy },
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    selectedFlatRows,
    toggleAllRowsSelected,
    setGlobalFilter,
    rows,
    setColumnOrder,
  } = useTable(
    dataHooks,
    useColumnOrder,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    useFlexLayout,
    useResizeColumns,
    (hooks) => {
      hooks.visibleColumns.push((columns: any) => {
        const optionsColums = showDetail && showChekbox ? dataTableDetail : null
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        showUnlock ? dataTableUnlock : null
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        showReset ? dataTableReset : null
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        showChange ? dataTableChange : null
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        showBlock ? dataTableBlock : null
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        areRowReplayable ? dataTableReplayable : null
        if (
          showDetail ||
          showUserDetail ||
          showChekbox ||
          areRowDeletable ||
          areRowEditable ||
          areRowReplayable ||
          isPassword ||
          areRowDownloadable ||
          showUnlock ||
          showReset ||
          showChange ||
          showBlock ||
          showBrInfo
        ) {
          return [
            isBR
              ? {
                  id: dataTableBR.id,
                  Header: '',
                  Cell: ({ row }) => {
                    return dataTableBR.iconRow({
                      row,
                      onInfoBR,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn5',
                  isVisible: false,
                },
            showChekbox || showDetail
              ? {
                  id: dataTable.id,
                  Header: selectAll
                    ? ({ getToggleAllPageRowsSelectedProps }) => {
                        const globalCheckboxProps = {
                          onChange:
                            getToggleAllPageRowsSelectedProps().onChange,
                          style: getToggleAllPageRowsSelectedProps().style,
                          checked: getToggleAllPageRowsSelectedProps().checked,
                          indeterminate:
                            getToggleAllPageRowsSelectedProps().indeterminate,
                        }
                        return <TableCheckbox {...globalCheckboxProps} />
                      }
                    : '',
                  Cell: ({ row }) => {
                    return dataTable.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onDeleteRow,
                      onDetailClick,
                      summaryDetail,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn0',
                  isVisible: false,
                },
            ...columns,
            showUserDetail
              ? {
                  id: dataTableUserDetail.id,
                  Header: '',
                  Cell: ({ row }) => {
                    return dataTableUserDetail.iconRow({
                      row,
                      onUserDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn8',
                  isVisible: false,
                },
            showReset
              ? {
                  id: dataTableReset.id,
                  Header: <FormattedMessage {...messages.RESET} />,
                  Cell: ({ row }) => {
                    return dataTableReset.iconRow({
                      row,
                      onResetRow,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn11',
                  isVisible: false,
                },
            showUnlock
              ? {
                  id: dataTableUnlock.id,
                  Header: <FormattedMessage {...messages.UNLOCK} />,
                  Cell: ({ row }) => {
                    return dataTableUnlock.iconRow({
                      row,
                      onUnlockRow,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn9',
                  isVisible: false,
                },
            showChange
              ? {
                  id: dataTableChange.id,
                  Header: <FormattedMessage {...messages.CHANGE} />,
                  Cell: ({ row }) => {
                    return dataTableChange.iconRow({
                      row,
                      onChangeRow,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn10',
                  isVisible: false,
                },
            showBlock
              ? {
                  id: dataTableBlock.id,
                  Header: <FormattedMessage {...messages.BLOCK} />,
                  Cell: ({ row }) => {
                    return dataTableBlock.iconRow({
                      row,
                      onBlockRow,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn12',
                  isVisible: false,
                },
            temporary
              ? {
                  id: dataTableTemporary.id,
                  Header: () => '',
                  Cell: ({ row }) => {
                    return dataTableTemporary.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onDeleteRow,
                      onDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn14',
                  isVisible: false,
                },
            areRowEditable
              ? {
                  id: showChekbox
                    ? dataTableModify.id
                    : showDetail
                    ? dataTableModify.id
                    : 'MODIFY',
                  Header: '',
                  Cell: ({ row }) => {
                    if (showDetail) {
                      return dataTableModify.iconRow({
                        row,
                        detailURL,
                        changeLocation,
                        onEditRow,
                        onDetailClick,
                      })
                    }
                    if (showChekbox) {
                      return dataTableModify.iconRow({
                        row,
                        detailURL,
                        changeLocation,
                        onEditRow,
                        onDetailClick,
                      })
                    }
                    return dataTableModify.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onEditRow,
                      onDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn1',
                  isVisible: false,
                },
            areRowDeletable
              ? {
                  id: areRowEditable ? dataTableDelete.id : dataTableDelete.id,
                  Header: '',
                  Cell: ({ row }) => {
                    if (areRowEditable || showDetail) {
                      return dataTableDelete.iconRow({
                        row,
                        detailURL,
                        changeLocation,
                        onDeleteRow,
                        onDetailClick,
                      })
                    }
                    return dataTableDelete.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onDeleteRow,
                      onDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn2',
                  isVisible: false,
                },
            areRowDownloadable
              ? {
                  id: dataTableDownload.id,
                  Header: '',
                  Cell: ({ row }) => {
                    return dataTableDownload.iconRow({
                      row,
                      onDownloadRow,
                      // onDeleteRow,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : { id: 'emptyColumn7', isVisible: false },
            isPassword
              ? {
                  id: isPassword ? dataTablePassword.id : dataTable.id,
                  Header: '',
                  Cell: ({ row }) => {
                    return dataTablePassword.iconRow({
                      row,
                      detailURL,
                      onPasswordClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn6',
                  isVisible: false,
                },
            optionsColums
              ? {
                  id: optionsColums.id,
                  Header: () => '',
                  Cell: ({ row }) => {
                    return optionsColums.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onDeleteRow,
                      onDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn3',
                  isVisible: false,
                },
            violationOfVisibility
              ? {
                  id: dataTableViolationVisibility.id,
                  Header: () => '',
                  Cell: ({ row }) => {
                    return dataTableViolationVisibility.iconRow({
                      row,
                      detailURL,
                      changeLocation,
                      onDeleteRow,
                      onDetailClick,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn4',
                  isVisible: false,
                },
            areRowReplayable
              ? {
                  id: dataTableReplayable.id,
                  Header: '',
                  Cell: ({ row }) => {
                    return dataTableReplayable.iconRow({
                      row,
                      detailURL,
                      onReplay,
                    })
                  },
                  width: 25,
                  maxWidth: 25,
                }
              : {
                  id: 'emptyColumn13',
                  isVisible: false,
                },
          ]
        } else {
          return [...columns]
        }
      })
    }
  )

  //
  const filteredRows = rows.map(row => row.original)

  // SERVER SIDE PAGINATION
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
    } else {
      if (fetchData && filterProps && !serverSideSorting) {
        if (pNumber === pageIndex && pSize === pageSize) {
          fetchData(0, pageSize, filterProps)
          pNumber = 0
        } else {
          fetchData(pageIndex, pageSize, filterProps)
          pNumber = pageIndex
        }
        pSize = pageSize
      }
    }
  }, [pageIndex, pageSize, filterProps])

  const isFirstRenderSort = useRef(true)
  useEffect(() => {
    if (isFirstRenderSort.current) {
      isFirstRenderSort.current = false
    } else {
      if (fetchData && filterProps && serverSideSorting) {
        if (pNumber === pageIndex && pSize === pageSize) {
          fetchData(0, pageSize, filterProps, sortBy)
          pNumber = 0
        } else {
          fetchData(pageIndex, pageSize, filterProps, sortBy)
          pNumber = pageIndex
        }
        pSize = pageSize
      }
    }
  }, [pageIndex, pageSize, sortBy, filterProps])

  useEffect(() => {
    if (onCheckboxChangeEvent && onCheckboxChange)
      onCheckboxChange(selectedFlatRows)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFlatRows])

  useEffect(() => {
    if (filterProps) setGlobalFilter(filterProps)
  }, [filterProps, setGlobalFilter])

  const rowCount = () => {
    if (serverSidePagination) return totalElements
    return rows ? rows.length : dataSource.length
  }
  const reorderColumns = () => {
    if (columnOrder !== undefined) {
      setColumnOrder(columnOrder)
    }
  }
  useEffect(() => {
    reorderColumns()
  }, [])

  // custom column order
  useEffect(() => {
    if (customColumnOrder) {
      setColumnOrder(customColumnOrder)
    }
  }, [customColumnOrder])

  if (dataSource.length === 0) {
    return <></>
  }

  return (
    <div className={classes['table-wrapper']}>
      <table className={classes.table} {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr className={classes.tr} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return dataTable.tdHeadRow(column, customHideColumns)
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            // console.log(row, "row");
            prepareRow(row)

            const { values, original } = row
            const classesStyle: any = (values: any, original: any) => {
              if (
                (values.editable !== 'undefined' &&
                  values.editable === false) ||
                (original.editable !== 'undefined' &&
                  original.editable === false) ||
                (values.available !== 'undefined' &&
                  values.available === false) ||
                (original.available !== 'undefined' &&
                  original.available === false)
              )
                return classes['row-not-editable']
              if (values.added || original.added) {
                if (
                  (values.involvedInSOD || original.involvedInSOD) &&
                  (values.temporary === false ||
                    original.temporary === 'undefined')
                ) {
                  return classes['row-sod-check']
                }
                return classes['row-not-added']
              }
              if ((values.deleted || original.deleted) && !SODDeletedSummary)
                return classes['row-not-deleted']
              if ((values.deleted || original.deleted) && SODDeletedSummary)
                return ''
              if (row.isSelected) {
                return classes['row-selected']
              }
              return ''
            }
            return (
              <tr
                className={classesStyle(values, original)}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => {
                  //costruzione del td body
                  return dataTable.tdBodyRow(cell, customHideCells)
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className={classes.rowFound}>
        <FormattedMessage {...messages.rowsFound} />
        {rowCount()}
      </div>
      <div style={{ width: '100%', textAlign: 'center', position: 'relative' }}>
        <div style={{ display: 'inline-block' }}>
          <Pagination
            showWhiteAndBlack={showWhiteAndBlack}
            toggleAllRowsSelected={toggleAllRowsSelected}
            messages={messages}
            gotoPage={gotoPage}
            previousPage={previousPage}
            setPageSize={setPageSize}
            nextPage={nextPage}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageSize={pageSize}
            pageOptions={pageOptions}
            pageCount={pageCount}
            rowsChangeable={rowsChangeable}
            showCTAButton={showCTAButton}
            selectedFlatRows={selectedFlatRows}
            onCheckboxChange={onCheckboxChange}
          />
        </div>
        <div
          className={classes['pagination-wrapper']}
          style={{ display: 'inline-block', position: 'absolute', right: '0%' }}
        >
          {onClickCSV === undefined ? (
            <div
              style={
                CSVDisabled
                  ? { pointerEvents: 'none', opacity: 0.75 }
                  : { pointerEvents: 'auto', opacity: 1 }
              }
              onClick={onClickCSV}
            >
              <CSVLink
                filename={`${tableName}_${actualDate}.csv`}
                data={checkDatasourceForWrapText(filteredRows)!}
                separator={'|'}
                ref={CSVRef}
              >
                <button className={classes.csvBtnWrapper}>
                  <FaFileCsv />
                </button>
              </CSVLink>
            </div>
          ) : (
            <>
              {tempData.length > 0 && (
                <CSVLink
                  filename={`${tableName}_${actualDate}.csv`}
                  data={checkDatasourceForWrapText(filteredRows)!}
                  separator={'|'}
                  ref={CSVRef}
                ></CSVLink>
              )}
              <div
                className={classes.csvBtnWrapper}
                onClick={onClickCSV}
                style={
                  CSVDisabled
                    ? { pointerEvents: 'none', opacity: 0.75 }
                    : { pointerEvents: 'auto', opacity: 1 }
                }
              >
                <FaFileCsv />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    tablesConfiguration: selectTablesConfiguration,
  })

const mapDispatchToProps: any = {
  changeLocation: (url: string) => push(url),
}

const withConnect: any = connect(mapStateToProps, mapDispatchToProps)

export default withConnect(Table)
